(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jsq-atelier-footer"] && !Shopify.designMode) return;
  try {
    (() => {
  const phone = matchMedia('(max-width: 768px)');
  const sync = () => document.querySelectorAll('.jsqa-footer details').forEach(item => { item.open = !phone.matches; });
  sync();
  phone.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jsq-catalog-controls"] && !Shopify.designMode) return;
  try {
    (function(){
  function normalize(value){return String(value||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().trim();}
  function update(group){
    var input=group.querySelector('[data-jqr-filter-search]');
    if(!input)return;
    var terms=normalize(input.value).split(/\s+/).filter(Boolean);
    var matches=0;
    group.querySelectorAll('[data-jqr-filter-label]').forEach(function(row){
      var label=normalize(row.getAttribute('data-jqr-filter-label'));
      var match=terms.every(function(term){return label.indexOf(term)!==-1;});
      var selected=row.querySelector('input[type="checkbox"]').checked;
      row.hidden=!match&&!selected;
      if(match)matches++;
    });
    var status=group.querySelector('[data-jqr-filter-status]');
    status.textContent=status.getAttribute('data-result-label').replace('__COUNT__',String(matches));
    group.querySelector('[data-jqr-filter-empty]').hidden=matches>0;
  }
  function initialize(scope){
    scope.querySelectorAll('[data-jqr-filter-finder]').forEach(function(finder){
      finder.hidden=false;
      update(finder.closest('.jqr-catalog-controls__group'));
    });
  }
  document.addEventListener('input',function(event){
    if(event.target.matches('[data-jqr-filter-search]'))update(event.target.closest('.jqr-catalog-controls__group'));
  });
  document.addEventListener('change',function(event){
    var group=event.target.closest('.jqr-catalog-controls__group');
    if(group&&event.target.matches('input[type="checkbox"]'))update(group);
  });
  document.addEventListener('click',function(event){
    var button=event.target.closest('[data-jqr-filter-clear]');
    if(!button)return;
    var group=button.closest('.jqr-catalog-controls__group');
    var input=group.querySelector('[data-jqr-filter-search]');
    input.value='';
    update(group);
    input.focus();
  });
  document.addEventListener('keydown',function(event){
    if(!event.target.matches('[data-jqr-filter-search]'))return;
    if(event.key==='Enter')event.preventDefault();
    if(event.key==='Escape'&&event.target.value){event.preventDefault();event.target.value='';update(event.target.closest('.jqr-catalog-controls__group'));}
  });
  document.addEventListener('shopify:section:load',function(event){initialize(event.target);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initialize(document);});
  else initialize(document);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jsq-gemara-navigation"] && !Shopify.designMode) return;
  try {
    (function(){
  const preview=new URLSearchParams(location.search).get('preview_theme_id');
  if(preview&&/^\d+$/.test(preview))document.querySelectorAll('.jsq-gemara-nav a[href^="/"]').forEach(a=>{const u=new URL(a.getAttribute('href'),location.origin);u.searchParams.set('preview_theme_id',preview);a.href=u.pathname+u.search+u.hash;});
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.jsq-gemara-nav details[open]').forEach(d=>d.open=false);});
  document.addEventListener('click',event=>document.querySelectorAll('.jsq-gemara-nav details[open]').forEach(d=>{if(!d.contains(event.target))d.open=false;}));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["judaica-megamenu-original-pre-tishrei-20260915"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.customElements && !customElements.get('judaica-megamenu')) {
      customElements.define('judaica-megamenu', class extends HTMLElement {
        connectedCallback() {
          var self = this;
          var hideTimer = null;
          var activeTrigger = null;
          var suppressFocusOpen = false;
          var triggers = self.querySelectorAll('.jz-mm__trigger[data-target]');
          var panels = self.querySelectorAll('.jz-mm__panel');
          function close(restoreFocus) {
            clearTimeout(hideTimer);
            triggers.forEach(function(trigger) {
              trigger.setAttribute('aria-expanded', 'false');
            });
            panels.forEach(function(panel) {
              panel.classList.remove('is-open');
              panel.setAttribute('hidden', '');
            });
            var triggerToRestore = activeTrigger;
            activeTrigger = null;
            if (restoreFocus && triggerToRestore) {
              suppressFocusOpen = true;
              triggerToRestore.focus();
              suppressFocusOpen = false;
            }
          }
          function scheduleClose() {
            clearTimeout(hideTimer);
            hideTimer = setTimeout(function() { close(false); }, 180);
          }
          function show(id, trigger) {
            clearTimeout(hideTimer);
            activeTrigger = trigger;
            triggers.forEach(function(item) {
              item.setAttribute('aria-expanded', item.dataset.target === id ? 'true' : 'false');
            });
            panels.forEach(function(p){
              var on = p.dataset.panel === id;
              p.classList.toggle('is-open', on);
              if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
            });
          }
          triggers.forEach(function(trigger) {
            var panel = self.querySelector('[data-panel="' + trigger.dataset.target + '"]');
            if (panel) {
              panel.id = 'jz-mm-panel-' + trigger.dataset.target;
              trigger.setAttribute('aria-controls', panel.id);
            }
            trigger.addEventListener('mouseenter', function() { show(trigger.dataset.target, trigger); });
            trigger.addEventListener('focus', function() {
              if (!suppressFocusOpen) show(trigger.dataset.target, trigger);
            });
            trigger.addEventListener('mouseleave', scheduleClose);
            trigger.addEventListener('keydown', function(event) {
              if (event.key !== 'ArrowDown' || !panel) return;
              var firstLink = panel.querySelector('a[href]');
              if (!firstLink) return;
              event.preventDefault();
              show(trigger.dataset.target, trigger);
              firstLink.focus();
            });
          });
          panels.forEach(function(panel) {
            panel.addEventListener('mouseenter', function() { clearTimeout(hideTimer); });
            panel.addEventListener('focusin', function() { clearTimeout(hideTimer); });
            panel.addEventListener('mouseleave', scheduleClose);
            panel.addEventListener('focusout', function(event) {
              if (!self.contains(event.relatedTarget)) scheduleClose();
            });
          });
          document.addEventListener('pointerdown', function(event) {
            if (!self.contains(event.target)) close(false);
          });
          document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && activeTrigger) {
              event.preventDefault();
              close(true);
            }
          });
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["judaica-megamenu-original"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.customElements && !customElements.get('judaica-megamenu')) {
      customElements.define('judaica-megamenu', class extends HTMLElement {
        connectedCallback() {
          var self = this;
          var hideTimer = null;
          var activeTrigger = null;
          var suppressFocusOpen = false;
          var triggers = self.querySelectorAll('.jz-mm__trigger[data-target]');
          var panels = self.querySelectorAll('.jz-mm__panel');
          function close(restoreFocus) {
            clearTimeout(hideTimer);
            triggers.forEach(function(trigger) {
              trigger.setAttribute('aria-expanded', 'false');
            });
            panels.forEach(function(panel) {
              panel.classList.remove('is-open');
              panel.setAttribute('hidden', '');
            });
            var triggerToRestore = activeTrigger;
            activeTrigger = null;
            if (restoreFocus && triggerToRestore) {
              suppressFocusOpen = true;
              triggerToRestore.focus();
              suppressFocusOpen = false;
            }
          }
          function scheduleClose() {
            clearTimeout(hideTimer);
            hideTimer = setTimeout(function() { close(false); }, 180);
          }
          function show(id, trigger) {
            clearTimeout(hideTimer);
            activeTrigger = trigger;
            triggers.forEach(function(item) {
              item.setAttribute('aria-expanded', item.dataset.target === id ? 'true' : 'false');
            });
            panels.forEach(function(p){
              var on = p.dataset.panel === id;
              p.classList.toggle('is-open', on);
              if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
            });
          }
          triggers.forEach(function(trigger) {
            var panel = self.querySelector('[data-panel="' + trigger.dataset.target + '"]');
            if (panel) {
              panel.id = 'jz-mm-panel-' + trigger.dataset.target;
              trigger.setAttribute('aria-controls', panel.id);
            }
            trigger.addEventListener('mouseenter', function() { show(trigger.dataset.target, trigger); });
            trigger.addEventListener('focus', function() {
              if (!suppressFocusOpen) show(trigger.dataset.target, trigger);
            });
            trigger.addEventListener('mouseleave', scheduleClose);
            trigger.addEventListener('keydown', function(event) {
              if (event.key !== 'ArrowDown' || !panel) return;
              var firstLink = panel.querySelector('a[href]');
              if (!firstLink) return;
              event.preventDefault();
              show(trigger.dataset.target, trigger);
              firstLink.focus();
            });
          });
          panels.forEach(function(panel) {
            panel.addEventListener('mouseenter', function() { clearTimeout(hideTimer); });
            panel.addEventListener('focusin', function() { clearTimeout(hideTimer); });
            panel.addEventListener('mouseleave', scheduleClose);
            panel.addEventListener('focusout', function(event) {
              if (!self.contains(event.relatedTarget)) scheduleClose();
            });
          });
          document.addEventListener('pointerdown', function(event) {
            if (!self.contains(event.target)) close(false);
          });
          document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && activeTrigger) {
              event.preventDefault();
              close(true);
            }
          });
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
